// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assistance-container {
  width: 100%;
  padding: 0;
}

.faq-header,
.glossary-item-header {
  /* background-color: #595959; */
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  padding: 1rem;
  /* color: #fffdfc; */
  font-size: 2rem !important;
}

.faq-container,
.contact-faq-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.faq-content {
  background: #fffdfc;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  /* border-bottom-right-radius: 10px; */
  /* padding: 2rem; */
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
  /* gap: 8px; */
}

.faq-question {
  border-bottom: 1px solid #eee;
}

.faq-question:last-of-type {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border: none;
}

.faq-question:first-of-type {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.faq-question:hover {
  background-color: #f2f2f2;
}

.faq-question button {
  text-align: start;
  width: 100%;
  padding: 1.5rem;
}

.faq-question-text {
  font-weight: 600;
}

.faq-answer {
  margin-top: 1rem;
}

.active-question {
  background-color: #f2f2f2;
}

.glossary {
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 3 colonnes */
  gap: 20px; /* espace entre les items */
  margin-top: 20px;
}

.glossary-item {
  background: #fffdfc;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.glossary-item-content {
  padding: 1rem;
}

.glossary-container-vertical {
  padding: 10px;
}

.glossary-select-wrapper {
  margin-bottom: 15px;
}

.glossary-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.glossary-list-item {
  padding: 1.5rem;
  border-bottom: 1px solid #eee;
}

.glossary-list-item:hover {
  background-color: #f2f2f2;
}

.glossary-list-item:last-of-type {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border: none;
}

.glossary-list-item:first-of-type {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.glossary-item-term {
  font-weight: 700;
}

/* === GUIDES D'UTILISATION === */

.guides-container {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem;
  margin-top: 2rem;
  align-items: center;
}

.guide-card {
  background: #ffffff;
  border: 1px solid #e3e3e3;
  border-radius: 16px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
  padding: 2rem;
  width: 100%;
  max-width: 720px;
  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.guide-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);
}

.guide-card-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #2d2d2d;
  margin-bottom: 0.5rem;
}

.guide-card-description {
  font-size: 1.25rem;
  color: #555;
  margin-bottom: 2rem;
}

.guide-video-wrapper {
  position: relative;
  width: 100%;
  padding-bottom: 56.25%; /* ratio 16:9 */
  margin-bottom: 1.5rem;
}

.guide-video-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 12px;
}

.contact-button-container {
  padding: 2rem;
  background-color: #ffffff;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);
  margin-top: 1rem;
}

.contact-container {
  padding: 0 2rem;
  margin-top: 1rem;
}

.contact-container p {
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #333;
}

.contact-button-container .action-buttons {
  justify-content: flex-start !important;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content.ticket {
  background: #fff;
  padding: 0px !important;
  border-radius: 14px;
  max-width: 600px;
  width: 90%;
  position: relative;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 12px;
  background: none;
  border: none;
  font-size: 22px;
  cursor: pointer;
}

/* === TICKETS SUPPORT === */

.tickets-support {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  margin-top: 2rem;
}

.tickets-panel {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 1.5rem;
  padding: 2.4rem;
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
}

.tickets-panel__header {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
  justify-content: space-between;
  align-items: flex-start;
}

.tickets-panel__eyebrow {
  font-size: 1.2rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #6366f1;
  margin-bottom: 0.6rem;
}

.tickets-panel__description {
  margin-top: 0.75rem;
  color: #475569;
}

.tickets-panel__header-actions {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.tickets-panel__body {
  margin-top: 2rem;
}

.tickets-feedback {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.5rem;
  border: 1px dashed #cbd5f5;
  border-radius: 1rem;
  background: #f8fafc;
  color: #0f172a;
}

.tickets-feedback--loading {
  font-weight: 600;
}

.tickets-feedback--muted {
  background: #fff7ed;
  border-color: #fed7aa;
  color: #9a3412;
  flex-direction: column;
  align-items: flex-start;
}

.tickets-feedback--empty {
  flex-direction: column;
  text-align: center;
  color: #475569;
}

.tickets-spinner {
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  border: 3px solid #dbeafe;
  border-top-color: #2563eb;
  animation: tickets-spin 0.8s linear infinite;
}

@keyframes tickets-spin {
  to {
    transform: rotate(360deg);
  }
}

.tickets-panel--secondary {
  background: linear-gradient(135deg, #312e81, #1e3a8a);
  color: #f8fafc;
}

.tickets-panel--secondary p {
  color: #e0e7ff;
}

.tickets-panel__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 1.5rem;
}

.ticket-reload-text {
  margin-top: 1rem;
  color: #475569;
}

/* === RICHTEXT GLOSSAIRE (ul > li > strong : term) === */

.glossary-container-full.richtext-content ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  background-color: white;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.glossary-container-full.richtext-content li {
  padding: 1.5rem;
  border-bottom: 1px solid #eee;
  font-size: 1.3rem;
  color: #374151;
}

.glossary-container-full.richtext-content li:hover {
  background-color: #f2f2f2;
}

.glossary-container-full.richtext-content li:last-of-type {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  border: none;
}

.glossary-container-full.richtext-content li:first-of-type {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.glossary-container-full.richtext-content li strong {
  font-weight: 700;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Assistance/Assistance.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;;EAEE,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,aAAa;EACb,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qCAAqC,EAAE,eAAe;EACtD,SAAS,EAAE,2BAA2B;EACtC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,iCAAiC;;AAEjC;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB;;wBAEsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB,EAAE,eAAe;EACvC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA,4BAA4B;;AAE5B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yDAAyD;;AAEzD;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".assistance-container {\n  width: 100%;\n  padding: 0;\n}\n\n.faq-header,\n.glossary-item-header {\n  /* background-color: #595959; */\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  padding: 1rem;\n  /* color: #fffdfc; */\n  font-size: 2rem !important;\n}\n\n.faq-container,\n.contact-faq-container {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.faq-content {\n  background: #fffdfc;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  /* border-bottom-right-radius: 10px; */\n  /* padding: 2rem; */\n  margin-bottom: 2rem;\n  display: flex;\n  flex-direction: column;\n  /* gap: 8px; */\n}\n\n.faq-question {\n  border-bottom: 1px solid #eee;\n}\n\n.faq-question:last-of-type {\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border: none;\n}\n\n.faq-question:first-of-type {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.faq-question:hover {\n  background-color: #f2f2f2;\n}\n\n.faq-question button {\n  text-align: start;\n  width: 100%;\n  padding: 1.5rem;\n}\n\n.faq-question-text {\n  font-weight: 600;\n}\n\n.faq-answer {\n  margin-top: 1rem;\n}\n\n.active-question {\n  background-color: #f2f2f2;\n}\n\n.glossary {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr); /* 3 colonnes */\n  gap: 20px; /* espace entre les items */\n  margin-top: 20px;\n}\n\n.glossary-item {\n  background: #fffdfc;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n}\n\n.glossary-item-content {\n  padding: 1rem;\n}\n\n.glossary-container-vertical {\n  padding: 10px;\n}\n\n.glossary-select-wrapper {\n  margin-bottom: 15px;\n}\n\n.glossary-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n}\n\n.glossary-list-item {\n  padding: 1.5rem;\n  border-bottom: 1px solid #eee;\n}\n\n.glossary-list-item:hover {\n  background-color: #f2f2f2;\n}\n\n.glossary-list-item:last-of-type {\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border: none;\n}\n\n.glossary-list-item:first-of-type {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.glossary-item-term {\n  font-weight: 700;\n}\n\n/* === GUIDES D'UTILISATION === */\n\n.guides-container {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 2rem;\n  margin-top: 2rem;\n  align-items: center;\n}\n\n.guide-card {\n  background: #ffffff;\n  border: 1px solid #e3e3e3;\n  border-radius: 16px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);\n  padding: 2rem;\n  width: 100%;\n  max-width: 720px;\n  transition:\n    transform 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.guide-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08);\n}\n\n.guide-card-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #2d2d2d;\n  margin-bottom: 0.5rem;\n}\n\n.guide-card-description {\n  font-size: 1.25rem;\n  color: #555;\n  margin-bottom: 2rem;\n}\n\n.guide-video-wrapper {\n  position: relative;\n  width: 100%;\n  padding-bottom: 56.25%; /* ratio 16:9 */\n  margin-bottom: 1.5rem;\n}\n\n.guide-video-wrapper iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 12px;\n}\n\n.contact-button-container {\n  padding: 2rem;\n  background-color: #ffffff;\n  border: 1px solid #e3e3e3;\n  border-radius: 8px;\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.05);\n  margin-top: 1rem;\n}\n\n.contact-container {\n  padding: 0 2rem;\n  margin-top: 1rem;\n}\n\n.contact-container p {\n  font-size: 1.5rem;\n  margin-bottom: 1.5rem;\n  color: #333;\n}\n\n.contact-button-container .action-buttons {\n  justify-content: flex-start !important;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.modal-content.ticket {\n  background: #fff;\n  padding: 0px !important;\n  border-radius: 14px;\n  max-width: 600px;\n  width: 90%;\n  position: relative;\n  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.2);\n}\n\n.modal-close {\n  position: absolute;\n  top: 10px;\n  right: 12px;\n  background: none;\n  border: none;\n  font-size: 22px;\n  cursor: pointer;\n}\n\n/* === TICKETS SUPPORT === */\n\n.tickets-support {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.tickets-panel {\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 1.5rem;\n  padding: 2.4rem;\n  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);\n}\n\n.tickets-panel__header {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2rem;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.tickets-panel__eyebrow {\n  font-size: 1.2rem;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  color: #6366f1;\n  margin-bottom: 0.6rem;\n}\n\n.tickets-panel__description {\n  margin-top: 0.75rem;\n  color: #475569;\n}\n\n.tickets-panel__header-actions {\n  display: flex;\n  gap: 1rem;\n  align-items: center;\n}\n\n.tickets-panel__body {\n  margin-top: 2rem;\n}\n\n.tickets-feedback {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.5rem;\n  border: 1px dashed #cbd5f5;\n  border-radius: 1rem;\n  background: #f8fafc;\n  color: #0f172a;\n}\n\n.tickets-feedback--loading {\n  font-weight: 600;\n}\n\n.tickets-feedback--muted {\n  background: #fff7ed;\n  border-color: #fed7aa;\n  color: #9a3412;\n  flex-direction: column;\n  align-items: flex-start;\n}\n\n.tickets-feedback--empty {\n  flex-direction: column;\n  text-align: center;\n  color: #475569;\n}\n\n.tickets-spinner {\n  width: 1.5rem;\n  height: 1.5rem;\n  border-radius: 50%;\n  border: 3px solid #dbeafe;\n  border-top-color: #2563eb;\n  animation: tickets-spin 0.8s linear infinite;\n}\n\n@keyframes tickets-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.tickets-panel--secondary {\n  background: linear-gradient(135deg, #312e81, #1e3a8a);\n  color: #f8fafc;\n}\n\n.tickets-panel--secondary p {\n  color: #e0e7ff;\n}\n\n.tickets-panel__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.ticket-reload-text {\n  margin-top: 1rem;\n  color: #475569;\n}\n\n/* === RICHTEXT GLOSSAIRE (ul > li > strong : term) === */\n\n.glossary-container-full.richtext-content ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  background-color: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n}\n\n.glossary-container-full.richtext-content li {\n  padding: 1.5rem;\n  border-bottom: 1px solid #eee;\n  font-size: 1.3rem;\n  color: #374151;\n}\n\n.glossary-container-full.richtext-content li:hover {\n  background-color: #f2f2f2;\n}\n\n.glossary-container-full.richtext-content li:last-of-type {\n  border-bottom-left-radius: 10px;\n  border-bottom-right-radius: 10px;\n  border: none;\n}\n\n.glossary-container-full.richtext-content li:first-of-type {\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.glossary-container-full.richtext-content li strong {\n  font-weight: 700;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
